import { useLearnStockModal } from './learnStockModalContext';

/**
 * SeeItLive — inline chip that opens the Stock Modal as an overlay
 * on the current Learn page (no navigation, no refresh). Closing
 * the modal returns the reader to their scroll position in the
 * article.
 *
 * Props
 *   ticker — e.g. "UBER"
 *   tab    — Stock Modal tab id to open on, e.g. "capital-analytics",
 *            "stock-metrics", "insights", "triangle".
 *   tone   — visual accent: "emerald" (gem), "amber" (watch),
 *            "rose" (trap), "violet" (neutral/default).
 *   label  — override text; defaults to "See {TICKER} live &rarr;"
 */
const TONE_CLASSES = {
  emerald:
    'border-emerald-400/50 bg-emerald-500/10 text-emerald-600 dark:text-emerald-300 hover:bg-emerald-500/20 hover:border-emerald-500',
  amber:
    'border-amber-400/50 bg-amber-500/10 text-amber-600 dark:text-amber-300 hover:bg-amber-500/20 hover:border-amber-500',
  rose:
    'border-rose-400/50 bg-rose-500/10 text-rose-600 dark:text-rose-300 hover:bg-rose-500/20 hover:border-rose-500',
  violet:
    'border-violet-400/50 bg-violet-500/10 text-violet-600 dark:text-violet-300 hover:bg-violet-500/20 hover:border-violet-500',
};

export default function SeeItLive({ ticker, tab = 'capital-analytics', tone = 'violet', label }) {
  const { openLearnStock } = useLearnStockModal();
  const t = String(ticker || '').toUpperCase();
  const displayLabel = label || `See ${t} live \u2192`;
  const toneCls = TONE_CLASSES[tone] || TONE_CLASSES.violet;
  const onClick = (e) => {
    e.preventDefault();
    openLearnStock(t, tab);
  };
  return (
    <button
      type="button"
      onClick={onClick}
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-semibold no-underline align-baseline ${toneCls}`}
      data-testid={`see-it-live-${t.toLowerCase()}`}
    >
      {displayLabel}
    </button>
  );
}
